import { forwardRef, type SVGProps } from 'react';

export interface ExclamationCircleIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const ExclamationCircleIcon = forwardRef<SVGSVGElement, ExclamationCircleIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 40 40">
    <path
      d="M20 3.75C28.9746 3.75 36.25 11.0254 36.25 20C36.25 28.9746 28.9746 36.25 20 36.25C11.0254 36.25 3.75 28.9746 3.75 20C3.75 11.0254 11.0254 3.75 20 3.75ZM20 26.7822C18.6615 26.7824 17.5908 27.8539 17.5908 29.1924C17.591 30.5307 18.6617 31.6014 20 31.6016C21.3385 31.6016 22.41 30.5308 22.4102 29.1924C22.4102 27.8537 21.3386 26.7822 20 26.7822ZM20 8.39844C18.8401 8.39867 17.8586 9.4693 17.8584 10.8076L18.5723 23.0342C18.6615 23.9265 19.197 24.4617 20 24.4619C20.8032 24.4619 21.3395 23.8374 21.4287 23.0342L22.1426 10.8076C22.2316 9.46916 21.2493 8.39844 20 8.39844Z"
      fill="currentColor"
    />
  </svg>
));

ExclamationCircleIcon.displayName = 'ExclamationCircleIcon';
